import { useMemo } from 'react';

import ModalProvider from 'mui-modal-provider';

import { DrawerProvider } from '@cast/design-system';
import {
  OptimizationWorkloadsListContext,
  makeIsNamespaceWritable,
} from '@cast/split-me/features/cluster/workload-optimization';
import { useCluster } from '@cast/shared-cluster-context-data-access';
import { useOptimizationWorkloads } from '@cast/split-me/features/workload-optimization/hooks';
import { useWorkloadsAccessContextQuery } from '@cast/split-me/hooks';
import { TableSection } from './_components/TableSection/TableSection';

const AutoscalingContent = () => {
  const { cluster } = useCluster();

  const { workloads, isLoading, error, refetch } = useOptimizationWorkloads();

  const { data: accessContext, isLoading: isAccessContextLoading } =
    useWorkloadsAccessContextQuery({
      clusterId: cluster.id,
    });

  const isNamespaceWritable = useMemo(
    () => makeIsNamespaceWritable(accessContext),
    [accessContext]
  );

  return (
    <OptimizationWorkloadsListContext.Provider
      value={{
        isLoading: isLoading || isAccessContextLoading,
        workloads,
        hasError: !!error,
        refetch,
        isNamespaceWritable,
      }}
    >
      <DrawerProvider>
        <ModalProvider>
          <TableSection />
        </ModalProvider>
      </DrawerProvider>
    </OptimizationWorkloadsListContext.Provider>
  );
};

export const InventoryWorkloadsListAutoscaling = () => <AutoscalingContent />;
